import ProgressionApi from "../api/ProgressionApi";

export default class ProgressionService {
    static getProgressionLevels = (ticket: string, locale: string) => {
        return ProgressionApi.get(
            `/v1/progressionLevels?locale=${locale}`,
            {
                headers: {
                    'Ubi-AppId': process.env.REACT_APP_APP_ID,
                    'Authorization': `ubi_v1 t=${ticket}`
                }
            }
        );
    };

    static getUserProgressionLevel = (ticket: string, locale: string) => {
        return ProgressionApi.get(
            `/v1/users/me/progressionLevel?locale=${locale}`,
            {
                headers: {
                    'Ubi-AppId': process.env.REACT_APP_APP_ID,
                    'Authorization': `ubi_v1 t=${ticket}`
                }
            }
        );
    };
}